import React, { useContext, useEffect } from 'react';
import { availableSteps } from './PracticeJerseyBuilder';
import { PracticeJerseyOrderContext } from './PracticeJerseyBuilder';
import ColorOption from './ColorOption';
const Step = ({ children, currStep, step, setStep, available }) => {

    const { selectedCollection, selectedProduct, sizeData, collectionData, selectedDesign, includedProducts } = useContext(PracticeJerseyOrderContext);
    const PreviewSelection = () => {
        switch (step) {
            case 1:
            case "1":
                if (selectedCollection && collectionData) {
                    const collectionInfo = collectionData.find((collection) => collection.handle === selectedCollection);
                    console.log(collectionInfo)
                    return <div className="d-flex w-100 name-number">
                        <ColorOption product={collectionInfo} />
                    </div>
                }
                return ""
            case 2:
            case "2":
                if (selectedProduct) {
                    return <div className="d-flex w-100 name-number">
                        <ColorOption product={selectedProduct} />
                    </div>
                }
                return ""
            case 3:
            case "3":
                if (selectedDesign) {
                    return <div className="d-flex w-100 name-number">
                        <ColorOption product={selectedDesign} />
                    </div>
                }
                return ""
            case 4:
            case "4":
                if (includedProducts && includedProducts.length != 0) {
                    return <div className="d-flex w-100 name-number text-center">
                        <h1 className="Heading">{includedProducts.length}</h1>
                        <span>Products</span>
                    </div>
                }
                return ""
            default:
                return ""
        }
    }

    useEffect(() => {
    }, [selectedCollection, selectedProduct, sizeData, collectionData]);



    return (
        <div className={`step ${currStep === step ? 'Step--active' : ''}`} id={'step' + step}>
            <div className="step-header d-flex" onClick={() => setStep(step)}>
                <div className="d-block">
                    Step {step}
                    <h1 className={`Heading ${!available ? 'text-muted disabled' : ''}`}>{availableSteps[step - 1].heading}</h1>
                </div>
                <div className="ml-auto">
                    <PreviewSelection />
                </div>
            </div>
            <div className={`${currStep === step ? 'step-info' : 'd-none'}`}>
                {children}
            </div>

        </div>
    )
}

export default Step;
